import {
    legacy_createStore as createStore,
    combineReducers,
    applyMiddleware,
    compose,
} from 'redux'
import thunk from 'redux-thunk'
import { userReducer } from './User/reducer'
import { UserActionTypes } from './User/types'
import { inspectionReducer } from './Inspection/reducer'
import { InspectionActionTypes } from './Inspection/types'
import { ServiceRequestActionTypes } from './ServiceRequest/types'
import { serviceRequestReducer } from './ServiceRequest/reducer'
import { leaseReducer } from './Lease/reducer'
import { LeaseActionTypes } from './Lease/types'
import { billingReducer } from './Billing/reducer'
import { BillingActionTypes } from './Billing/types'

const rootReducer = combineReducers({
    user: userReducer,
    inspection: inspectionReducer,
    serviceRequest: serviceRequestReducer,
    lease: leaseReducer,
    billing: billingReducer,
})

export type AppActionTypes =
    | UserActionTypes
    | InspectionActionTypes
    | ServiceRequestActionTypes
    | BillingActionTypes
    | LeaseActionTypes

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose
    }
}
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(thunk)),
)

export type RootState = ReturnType<typeof rootReducer>
